import { combineReducers } from 'redux';
import locationReducer from './location';
import formsReducer from './forms';
import loadingReducer from './loading';
import userReducer from './user';

export const makeRootReducer = asyncReducers => combineReducers({
  location: locationReducer,
  forms: formsReducer,
  loading: loadingReducer,
  user: userReducer,
  // @generator reducers:combine
  ...asyncReducers
});

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer; // eslint-disable-line no-param-reassign
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
